import _default from "keen-slider";

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        InnerBlocks
    } = window.wp.editor;


    registerBlockType('custom-gutenberg/slider', {
        // built-in attributes
        title: 'Slider',
        description: 'Custom Slider',
        icon: 'slides',
        category: 'custom-components',
        example: {},

        attributes: {
            sliderId: {
                type: 'string',
                default: '',
                },
        },

        // built-in functions
        edit({attributes, setAttributes}) {

            if (!attributes.sliderId) {
                setAttributes({ sliderId: 'content-slider-' + Math.floor(Math.random() * 10000) });
            }

            return (
                /* pass this class content-slider as args, if you need to use this component with different number of cards displayed 
                   since we have only two sliders (object and this) in project, cards have fixed with and number of 2 defined in globals perView  */
                <div class="content-slider position-relative"> 
                    <div id="content-slider" class="keen-slider" style={ { opacity: '1' } }>
                        <InnerBlocks />
                    </div>
                    <div class="keen-slider__pager">
                        <div class="keen-slider__pager-buttons"></div>
                    </div>
                     <div className="keen-slider__arrows">
                        <div data-dir="prev"><i class="las la-arrow-left"></i></div>
                        <div data-dir="next"><i class="las la-arrow-right"></i></div>
                    </div>
                </div>
            );
        },

        save({attributes}) {

            const { sliderId } = attributes;

            return (
                <div className="content-slider position-relative" data-slider-id={ sliderId }>
                    <div id={ sliderId } className="keen-slider">
                        <InnerBlocks.Content />
                    </div>
                    <div className="keen-slider__pager">
                        <div className="keen-slider__pager-buttons"></div>
                    </div>
                    <div className="keen-slider__arrows">
                            <div ref="" data-dir="prev"><i class="las la-arrow-left"></i></div>
                            <div ref="" data-dir="next"><i class="las la-arrow-right"></i></div>
                        </div>
                </div>
            );
        },
    });
}